import { useContext, useState } from 'react';

import { AppContext } from '@r-app/app-context';
import type { CleanEdgeAddableCandidate } from '../helpers/generate-clean-edge-annotations';
import { getCleanEdgeManualOverrideKey } from '../helpers/generate-clean-edge-annotations';

export type RenderCleanEdgeAddCandidateProps = {
	islandId: string;
	candidate: CleanEdgeAddableCandidate;
	fontSize: number;
};

/**
 * A ghosted "CLEAN EDGE" placeholder on a side that doesn't have one yet. Click to add a manual
 * label there (#398) -- stored the same way as the auto ones, via kitchen.blueprintOverrides.
 * Only rendered while the hidden-dimensions toggle is on (see RenderCleanEdgeLabel), so it never
 * shows up in a PDF/PPTX export of the page.
 */
export const RenderCleanEdgeAddCandidate = (props: RenderCleanEdgeAddCandidateProps): React.ReactElement => {
	const { islandId, candidate, fontSize } = props;
	const { controller } = useContext(AppContext);
	const { kitchen, options } = controller;
	const [hovered, setHovered] = useState(false);

	if (options.readonly) return <></>;

	const rotation = candidate.rotation !== 0 ? `rotate(${candidate.rotation}, ${candidate.x}, ${candidate.y})` : undefined;

	return (
		<text
			x={candidate.x}
			y={candidate.y}
			fill="#C00000"
			fontSize={fontSize}
			fontWeight="bold"
			textAnchor="middle"
			opacity={hovered ? 0.6 : 0.25}
			style={{ userSelect: 'none', cursor: 'pointer', pointerEvents: 'auto' }}
			transform={rotation}
			onMouseEnter={() => setHovered(true)}
			onMouseLeave={() => setHovered(false)}
			onPointerDown={(event) => {
				event.stopPropagation();
				kitchen?.setBlueprintOverride(getCleanEdgeManualOverrideKey(islandId, candidate.side), '1');
			}}
		>
			+ CLEAN EDGE
		</text>
	);
};
